import { type PlanPricing } from '@air/api/types';

import { usePlansList } from '~/hooks/usePlansList';
import { useSubscriptionContext } from '~/providers/SubscriptionProvider';

export type Features = keyof PlanPricing['features'];

export const usePlanFeature = (featureName: Features): boolean => {
  const { data } = usePlansList();
  const plans = data?.plans ?? [];
  const { data: subscription } = useSubscriptionContext();

  /**
   * Demo workspaces demo the whole product, so every feature is on
   * @see https://air-labs-team.slack.com/archives/C018C7U0DQU/p1786107241603489
   */
  if (subscription?.plan === 'demo') {
    return true;
  }

  const relevantPlan = plans.find((plan) => plan.id === subscription?.plan);

  const hasFeatureInPlan = relevantPlan ? !!relevantPlan.features?.[featureName] : false;

  return hasFeatureInPlan;
};
